"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyType = void 0;
var SurveyType;
(function (SurveyType) {
    /**
     * A survey used to ask some extra questions to the user. Currently doesn't support commuting related questions.
     * It's mostly used for custom questions
     */
    SurveyType["followUp"] = "follow-up";
    /**
     *
     */
    SurveyType["onboarding"] = "onboarding";
})(SurveyType || (exports.SurveyType = SurveyType = {}));
//# sourceMappingURL=Surveys.js.map